import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import AlertDismissible from '../../Shared/Components/AlertDismissible'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { SIA_NAVY } from '../../constants/siaTheme'

const FollowUpForm = ({ policy, contactTypes, defaultDate }) => {
    const { flash, errors } = usePage().props
    const form = useForm({
        contact_date: defaultDate,
        cobranza_contact_type_id: '',
        responded: '',
        observations: '',
    })

    const submit = (e) => {
        e.preventDefault()
        form.post(route('cobranza.follow-up.store', policy.id))
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <Col xs={12}><Breadcrumbs currentPath="admin/cobranza/registros" /></Col>
            <Col xs={12} md={10} lg={8} className="mx-auto">
                <div className="card card-flush shadow-sm">
                    <div className="card-header">
                        <h3 className="card-title fw-bold">Datos necesarios para el registro</h3>
                        <div className="card-toolbar text-muted fs-7">
                            Póliza {policy.policy} — {policy.insured_name}
                        </div>
                    </div>
                    <div className="card-body">
                        <Form onSubmit={submit}>
                            <Row className="g-4">
                                <Col md={6}>
                                    <Form.Group className="mb-4">
                                        <Form.Label className="fw-bold">Fecha <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={form.data.contact_date}
                                            onChange={(e) => form.setData('contact_date', e.target.value)}
                                            isInvalid={!!errors.contact_date}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.contact_date}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-4">
                                        <Form.Label className="fw-bold">Tipo de contacto <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            value={form.data.cobranza_contact_type_id}
                                            onChange={(e) => form.setData('cobranza_contact_type_id', e.target.value)}
                                            isInvalid={!!errors.cobranza_contact_type_id}
                                        >
                                            <option value="">Seleccione una opción</option>
                                            {contactTypes.map((t) => (
                                                <option key={t.id} value={t.id}>{t.name}</option>
                                            ))}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">{errors.cobranza_contact_type_id}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-4">
                                        <Form.Label className="fw-bold">¿Le respondió? <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            value={form.data.responded}
                                            onChange={(e) => form.setData('responded', e.target.value)}
                                            isInvalid={!!errors.responded}
                                        >
                                            <option value="">Seleccione una opción</option>
                                            <option value="1">Sí</option>
                                            <option value="0">No</option>
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">{errors.responded}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-4">
                                        <Form.Label className="fw-bold">Observaciones <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={10}
                                            value={form.data.observations}
                                            onChange={(e) => form.setData('observations', e.target.value)}
                                            isInvalid={!!errors.observations}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.observations}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="text-center mt-4 d-flex justify-content-center gap-3">
                                <Link href={route('cobranza.records.index')} className="btn btn-light">Cancelar</Link>
                                <Button
                                    type="submit"
                                    disabled={form.processing}
                                    style={{ backgroundColor: SIA_NAVY, borderColor: SIA_NAVY }}
                                >
                                    Registrar
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

FollowUpForm.layout = (page) => <Layout title="Log de seguimiento">{page}</Layout>

export default FollowUpForm
